import React from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin, Instagram, Linkedin } from "lucide-react";
import { useT } from "@/lib/i18n";

export default function Footer() {
  const t = useT();
  return (
    <footer className="mt-32 border-t border-[#022a67] bg-[#020815] relative overflow-hidden" data-testid="site-footer">
      <div className="speed-lines" />
      <div className="container-ar py-16 grid grid-cols-1 md:grid-cols-4 gap-10 relative z-10">
        <div className="md:col-span-1">
          <Link to="/" className="flex items-center gap-3 mb-4">
            <img src="/images/misc/alight-logo.jpg" alt="Alight Racing" className="h-10 w-auto object-contain" />
          </Link>
          <p className="text-sm text-[#8ba3cc] max-w-xs">{t.footer_desc}</p>
        </div>

        <div>
          <div className="eyebrow mb-4">{t.footer_navigate}</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="text-white/80 hover:text-[#e77300]">{t.nav_home}</Link></li>
            <li><Link to="/about" className="text-white/80 hover:text-[#e77300]">{t.nav_about}</Link></li>
            <li><Link to="/sponsorship" className="text-white/80 hover:text-[#e77300]">{t.nav_shop}</Link></li>
            <li><Link to="/contact" className="text-white/80 hover:text-[#e77300]">{t.nav_contact}</Link></li>
          </ul>
        </div>

        <div>
          <div className="eyebrow mb-4">{t.footer_contact}</div>
          <ul className="space-y-3 text-sm text-white/80">
            <li className="flex items-start gap-2"><Mail className="w-4 h-4 mt-0.5 text-[#e77300] shrink-0" /><a href="mailto:Partnerships@alightracing.com" className="hover:text-[#e77300] break-all">Partnerships@alightracing.com</a></li>
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-[#e77300] shrink-0" />{t.footer_location}</li>
            <li className="flex items-center gap-3 mt-4">
              <a href="#" className="text-white/60 hover:text-[#e77300]" aria-label="Instagram"><Instagram className="w-5 h-5" /></a>
              <a href="#" className="text-white/60 hover:text-[#e77300]" aria-label="LinkedIn"><Linkedin className="w-5 h-5" /></a>
            </li>
          </ul>
        </div>

        <div>
          <div className="eyebrow mb-4">{t.footer_partner_with_us}</div>
          <p className="text-sm text-white/70 mb-4">{t.footer_partner_copy}</p>
          <Link to="/sponsorship" className="btn-racing primary" data-testid="footer-become-sponsor">
            <span>{t.nav_become_sponsor}</span>
          </Link>
        </div>
      </div>

      <div className="border-t border-[#022a67]">
        <div className="container-ar py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50 font-mono-alt tracking-wider">
          <div>© 2026 ALIGHT RACING · COLÉGIO UNIVERSITÁRIO LONDRINA</div>
          <div className="text-[#fdb429] font-display uppercase tracking-[0.3em] text-sm">{t.footer_tagline}</div>
        </div>
      </div>
    </footer>
  );
}
